import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../../../services/http-client.service';
import { Router } from '@angular/router';
import { ShopService } from '../../../../services/shop.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../../services/website-theme.service';
/**
 * Modal Component
 */
let ShopModalComponent = class ShopModalComponent {
    constructor(httpClient, router, shopService, sanitizer, themeService) {
        this.httpClient = httpClient;
        this.router = router;
        this.shopService = shopService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.quantity = 1;
        this.isValid = true;
        this.customData = {};
        this.customDataArray = [];
        this.selected = [];
        this.backColor = '';
        this.successColor = '';
        this.textColor = '';
        this.errorColor = '';
        this.dataLength = 0;
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.themeService.getTheme().subscribe((data) => {
            this.backColor = this.themeService.getStyleAttribute('modal_back_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
    }
    ngOnInit() {
        this.httpClient.get('shop/getproduct/' + this.data.id).subscribe((product) => {
            this.product = product;
            this.sum = this.product.price;
            this.customData = this.product.variations;
            this.dataLength = Object.keys(this.customData).length;
            if (this.customData !== null && this.dataLength > 0) {
                for (let key in this.customData) {
                    this.selected[key] = this.customData[key][0];
                    this.customDataArray.push({
                        key: key,
                        value: this.customData[key],
                    });
                }
            }
        });
    }
    addProduct() {
        delete this.product['variations'];
        this.product['custom_data'] = [];
        this.product['variations'] = {};
        for (let key in this.selected) {
            this.product['custom_data'].push(this.selected[key]);
            let i = key;
            let j = this.selected[key];
            let pair = { [i]: j };
            this.product['variations'] = Object.assign(Object.assign({}, this.product['variations']), pair);
        }
        if (!isNaN(this.quantity)) {
            if (this.quantity <= this.product.available) {
                if (!this.quantity) {
                    this.quantity = 1;
                    this.changeQuantity('none');
                    this.isValid = false;
                }
                else {
                    this.shopService.addProduct(this.data.id, this.quantity, this.product);
                    this.close();
                }
            }
            else {
                this.quantity = this.product.available;
                this.changeQuantity('none');
                this.isValid = false;
            }
        }
        else {
            this.isValid = false;
        }
    }
    validateNumber() {
    }
    changeQuantity(type, event = null) {
        if (type === 'plus' && this.quantity < this.product.available) {
            this.quantity++;
            this.sum = ((Math.round(this.product.price * 100) / 100) * this.quantity).toFixed(2);
        }
        if (type === 'minus' && this.quantity > 0) {
            if (this.quantity === 1) {
                this.quantity = 1;
                this.sum = ((Math.round(this.product.price * 100) / 100) * this.quantity).toFixed(2);
            }
            else {
                this.quantity--;
                this.sum = ((Math.round(this.product.price * 100) / 100) * this.quantity).toFixed(2);
            }
        }
        if (type === 'none' && this.quantity > 0) {
            this.sum = ((Math.round(this.product.price * 100) / 100) * this.quantity).toFixed(2);
        }
        else if (type === 'none' && this.quantity <= 0 && event.keyCode !== 8) {
            this.quantity = 1;
            this.sum = ((Math.round(this.product.price * 100) / 100) * this.quantity).toFixed(2);
        }
    }
    close() {
        this.success();
        this.router.navigateByUrl('/shop');
        this.modal.destroy();
    }
};
ShopModalComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: Router },
    { type: ShopService },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
ShopModalComponent = __decorate([
    Component({
        selector: 'ecd-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./shop-modal.component.html")).default
    })
], ShopModalComponent);
export { ShopModalComponent };
